// import add from "./modules/add"
import bx from "./modules/bx";
import home from "./modules/home";
// import lp from "./modules/lp"
import person from "./modules/person";
import fx from "./modules/fx";
import qygl from "./modules/qygl";
import setting from "./modules/setting";
import serve from "./modules/serve";
// import zj from "./modules/zj"
import score from "./modules/score";
import serveManage from "./modules/serveManage";
import fxNew from "./modules/fxNew";
import expert from "./modules/expert";
import bxCom from "./modules/bxCom";
import closed from "./modules/closed";
import settle from "./modules/settle";

const frameIn = [bx, home, serve, person, fx, qygl, setting, score, serveManage, fxNew, expert, bxCom, closed, settle];
let userInfo = JSON.parse(localStorage.getItem("userinfo"));
let initListItem;
function isTzrb() {
  let flag = false;
  let type = userInfo ? userInfo.userType : "";
  if (type == 2) flag = true;
  return flag;
}
function isTzzj() {
  let flag = false;
  let type = userInfo ? userInfo.userType : "";
  if (type == 6) flag = true;
  return flag;
}
function isEmptyObj(obj) {
  return JSON.stringify(obj) === "{}";
}
if (userInfo && !isEmptyObj(userInfo)) {
  if (isTzzj()) {
    initListItem = {
      name: "dashboard",
      path: "/dashboard",
    };
  } else if (isTzrb()) {
    initListItem = {
      path: "/home/index",
      name: "homeIndex",
    };
  } else {
    initListItem = {
      path: "/home/tisindex",
      name: "homeTisindex",
    };
  }
}
// console.log(initListItem);
const frameOut = [
  {
    path: "/",
    redirect: initListItem ? initListItem.path : "/login",
    // redirect: "/dashboard",
    // name: '/',
    // component: () => import('@/views/login'),
    // meta: {
    //     title: '登录'
    // }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/bigScreen",
    name: "bigScreen",
    component: () => import("@/bigscreen/EquityGuarantee.vue"),
    meta: {
      title: "安全数据",
    },
  },
  {
    path: "/aqScreen",
    name: "aqScreen",
    component: () => import("@/bigscreen/aqScreen.vue"),
    meta: {
      title: "安全数据",
    },
  },
  {
    path: "/aqScreenJg",
    name: "aqScreenJg",
    component: () => import("@/bigscreen/aqScreenJg.vue"),
    meta: {
      title: "安全数据",
    },
  },
  {
    path: "/zhuguanbumeng",
    name: "zhuguanbumeng",
    component: () => import("@/bigscreen/zhuguanbumeng.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/teamData",
    name: "teamData",
    component: () => import("@/bigscreen/teamData.vue"),
    meta: {
      title: "团队数据",
    },
  },
  {
    path: "/insuranceData",
    name: "insuranceData",
    component: () => import("@/bigscreen/insuranceData.vue"),
    meta: {
      title: "保险数据",
    },
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("@/views/admin"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/excel",
    name: "excel",
    component: () => import("@/views/excel/index"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/regist",
    name: "regist",
    component: () => import("@/views/regist/index.vue"),
    meta: {
      title: "注册",
    },
  },
  {
    path: "/regist2",
    name: "regist2",
    component: () => import("@/views/regist"),
    meta: {
      title: "注册",
    },
  },
  {
    path: "reload",
    name: "reload",
    component: () => import("@/views/reload"),
  },
  {
    path: "*",
    component: () => import("@/views/404"),
    meta: {
      title: "404",
      sidebar: false,
    },
  },
];

// 导出需要显示菜单的
export const frameInRoutes = frameOut;

// 重新组织后导出
var list = [...frameIn, ...frameOut];

export var routerNames = JSON.parse(JSON.stringify(list));
export default list;
